import React from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import styled from '@emotion/native';
import { BodyText } from '@/shared/components/StyledText';
import { green } from '@/shared/styles/colors';
import { useRouter } from 'expo-router';
import { ROUTES } from '@/shared/constants/routes';

interface ViewPrivateNotesLinkProps {
  clientId: number;
  style?: StyleProp<ViewStyle>;
  fontSize?: number;
  showUnderline?: boolean;
  onPress?: () => void;
}

const ViewPrivateNotesLink: React.FC<ViewPrivateNotesLinkProps> = ({
  clientId,
  style,
  fontSize = 14,
  showUnderline = false,
  onPress,
}) => {
  const router = useRouter();

  const handlePress = () => {
    if (onPress) {
      onPress();
    }

    router.push(ROUTES.CLIENT_NOTES(clientId.toString()).path);
  };

  return (
    <TouchableOpacity
      onPress={handlePress}
      style={style}
      accessibilityHint="View private notes"
    >
      <LinkContainer>
        <LockIcon source={require('@/assets/images/LockIcon.png')} />
        <LinkText fontSize={fontSize} showUnderline={showUnderline}>
          View Private Notes
        </LinkText>
      </LinkContainer>
    </TouchableOpacity>
  );
};

const LinkContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
});

const LockIcon = styled.Image({
  width: 15,
  height: 15,
  marginRight: 4,
  tintColor: green,
});

const LinkText = styled(BodyText)<{ fontSize: number; showUnderline: boolean }>(
  ({ fontSize, showUnderline }) => ({
    color: green,
    fontSize,
    fontWeight: 'bold',
    letterSpacing: 0.14,
    textDecorationLine: showUnderline ? 'underline' : 'none',
  }),
);

export default ViewPrivateNotesLink;
